export default new class Counter {
  constructor() {
    this.init();
  }

  init() {

    const el = document.querySelector('#counter');

    if(el == null) {
        return;
    }

    this.startTimer(el);
  }

  startTimer(el) {

    clearInterval(this.prevNowPlaying);

    var draftedTime = el.textContent.split(':');
    let duration = parseInt(draftedTime[0]) * 60 + parseInt(draftedTime[1]);

    let timer = duration, minutes, seconds;
    this.prevNowPlaying = setInterval(
        function () {
            minutes = parseInt(timer / 60, 10);
            seconds = parseInt(timer % 60, 10);

            minutes = minutes < 10 ? "0" + minutes : minutes;
            seconds = seconds < 10 ? "0" + seconds : seconds;

            el.textContent = minutes + ":" + seconds;

            if (--timer < 0) {
                timer = duration;
            }
        }, 1000);
    }
}();